import { render, staticRenderFns } from "./all-betshops.vue?vue&type=template&id=687fb8ee"
import script from "./all-betshops.vue?vue&type=script&lang=js"
export * from "./all-betshops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports